<div class="shell-layout" [class.sidebar-expanded]="!isSidebarCollapsed()"
  [class.sidebar-collapsed]="isSidebarCollapsed()" [class.pos-session]="isPosSession">
  @if (!isPosSession) {
  @if (!isMobile) {
  <app-sidebar [isCollapsed]="isSidebarCollapsed()" [isMobile]="false" (collapsedToggle)="toggleSidebar()" />
  }

  @if (isMobile) {
  <app-mobile-topbar [isMenuOpen]="isMobileSidebarOpen()" (menuClick)="toggleSidebar()" />

  <div class="mobile-backdrop" [class.mobile-backdrop-visible]="isMobileSidebarOpen()" (click)="closeMobileSidebar()">
  </div>

  <div class="mobile-sidebar" [class.mobile-sidebar-open]="isMobileSidebarOpen()">
    <app-sidebar [isCollapsed]="false" [isMobile]="true" (collapsedToggle)="toggleSidebar()"
      (mobileClose)="closeMobileSidebar()" />
  </div>
  }
  }

  <main class="shell-content">
    <router-outlet />
  </main>
</div>